import { toNumber } from '../utils/toNumber'

export const pennyToRubles = (value: number | string) => (value ? Number((toNumber(value) / 100).toFixed(2)) : 0)
